<template>
  <div>
    <div class="productWrap">
      <div class="productDeco">
        <p v-if="$route.name === 'purchaseView'">
          <span class="postStatus">
            {{ status }}
            <i class="band"></i>
          </span>
        </p>
        <span
          v-if="product.type === 3 || product.type === 4 || product.type === 7"
          class="badge productBadge "
          :class="
            product.type === 3
              ? '_isDelivery'
              : product.type === 7
              ? '_isEvent'
              : '_isFunding'
          "
        >
          {{
            product.type === 3
              ? '배송상품'
              : product.type === 7
              ? '응모상품'
              : '펀딩상품'
          }}
        </span>
        <span class="productShopname">{{ shopName || product.shopName }}</span>
        <span class="productImg">
          <img :src="product.imageUrl" width="100%" height="100%" alt="" />
        </span>
        <span class="productName">{{ product.productName }}</span>
        <span class="productPrice">
          {{ product.price.addComma() }}{{ product.currencyUnit }}
        </span>
        <span class="productSale">
          {{
            isDiscount
              ? `${product.displayPrice.addComma()}${product.currencyUnit}`
              : ''
          }}
        </span>
        <span v-if="product.purchaseCount" class="productAmount">
          {{ product.purchaseCount.addComma() }}개
        </span>
      </div>
    </div>

    <div
      v-if="$route.name === 'purchaseView' && statusDescEnable"
      class="deliveryStatus"
    >
      <p class="statusDesc" :class="statusDescStyle" v-html="statusDesc"></p>
      <button
        v-if="buttonEnable"
        class="btn"
        :class="product.status === 121 ? 'btn_confirm' : ''"
        @click="handleStatus"
      >
        {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
import MyAPI from '@/api/my'
import {
  beforeSendLog,
  convertCouponStatus,
  covnertCancelStatus,
  convertPurchaseStatus,
  convertDeliveryPurchaseStatus
} from '@/utils'
import { mapActions } from 'vuex'

export default {
  name: 'ListItem',
  props: {
    shopName: {
      type: String,
      default: ''
    },
    product: {
      type: Object,
      default: () => ({})
    },
    productsCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    isDiscount() {
      return this.product.displayPrice - this.product.price > 0
    },
    status() {
      // 이거 버튼임
      let result = ''
      if (this.$route.name === 'purchaseView') {
        if (this.product.type === 3 || this.product.type === 4) {
          result = convertDeliveryPurchaseStatus(this.product.status)
        } else {
          result = convertPurchaseStatus(this.product.status)
        }
      } else if (this.$route.name !== 'purchase') {
        result = this.product.status
          ? convertCouponStatus(this.product.status)
          : covnertCancelStatus(this.product.withdrawStatus)
      }
      return result
    },
    statusDesc() {
      let desc = ''

      if (this.product.type === 3) {
        const status = this.product.status
        if (status === 120 || status === 121 || status === 150) {
          desc = this.shippingInfoComb
        }
      } else if (this.product.type === 4) {
        const status = this.product.status
        if (status === 100) {
          if (this.product.isGoal || this.product.isGoal === null) {
            // 목표달성 || 판매 진행 중
            const purchaseDate = this.product.startDeliveryDate.substring(0, 10)
            desc = `${purchaseDate} 이후 배송 예정`
          } else if (!this.product.isGoal) {
            // 목표 미달성
            desc = `목표를 달성하지 못해 결제 취소 예정`
          }
        } else if (status === 120) {
          desc = `${this.product.startDeliveryDate.substring(
            0,
            10
          )} 이후 배송 예정`
        } else if (status === 121 || status === 150) {
          desc = this.shippingInfoComb
        }
      }
      return desc
    },
    statusDescStyle() {
      if (
        this.product.type === 4 &&
        (this.product.status === 100 || this.product.status === 120)
      ) {
        return 'isFunding'
      }

      return ''
    },
    statusDescEnable() {
      const status = this.product.status

      if (this.product.type === 3 || this.product.type === 4) {
        // 제품이 1개 이상일 경우에는 표기
        if (this.productsCount > 1) {
          return true
        }

        if (status === 100 || status === 121 || status === 150) {
          return true
        }
        // 발송완료 상태에서는 송장 번호가 없으면 미노출
        else if (status === 120) {
          if (this.product.deliveryCompany || this.product.invoiceNumber) {
            return true
          }
        }
      }

      return false
    },
    buttonEnable() {
      const status = this.product.status

      if (this.product.type === 3) {
        return status === 100 || status === 121
      } else if (this.product.type === 4) {
        // 결제완료 상태이고, 아직 펀딩 진행 중일 경우
        if (
          status === 100 &&
          (this.product.isGoal === null || this.product.isGoal === undefined)
        ) {
          return true
        } else if (status === 121) {
          return true
        }
      }

      return false
    },
    buttonText() {
      if (this.product.status === 100) {
        return '주문취소'
      } else if (this.product.status === 121) {
        return '구매확정'
      }
      return ''
    },
    shippingInfoComb() {
      let desc = ''

      if (this.product.deliveryCompany) {
        desc += this.product.deliveryCompany
      }
      if (this.product.invoiceNumber) {
        if (this.product.deliveryCompany) {
          desc += `<span> | ${this.product.invoiceNumber}</span>`
        } else {
          desc += this.product.invoiceNumber
        }
      }
      return desc
    }
  },
  methods: {
    ...mapActions('modal', [
      'openModalRevokePurchase',
      'openModalConfirmPurchase',
      'openModal'
    ]),
    handleStatus() {
      if (this.product.status === 100) {
        this.openModalRevokePurchase(() => {
          MyAPI.reqCancelOrder(this.product.purchaseProductId, responseData => {
            if (responseData.code === 0) {
              beforeSendLog('Cancel', {
                ProductID: this.product.productId,
                ProductType: this.product.type
              })
              this.$emit('refreshDetail')
              this.openModal({
                type: 'alert',
                message: '주문취소가 처리되었습니다.'
              })
            }
          })
        })
      } else if (this.product.status === 121) {
        this.openModalConfirmPurchase(() => {
          MyAPI.reqPurchaseConfirm(
            this.product.purchaseProductId,
            responseData => {
              if (responseData.code === 0) {
                beforeSendLog('Confirm', {
                  ProductID: this.product.productId,
                  ProductType: this.product.type
                })
                this.$emit('refreshDetail')
                this.openModal({
                  type: 'alert',
                  message: '구매확정 처리되었습니다.'
                })
              }
            }
          )
        })
      }
    }
  }
}
</script>

<style lang="scss"></style>
